/** @format */
import { DropdownSelect, OrderType, SortOptionKey, SortType } from '../models';

export const SORT_DROPDOWN_OPTIONS: DropdownSelect[] = [
	{
		label: 'Newest',
		key: SortOptionKey.NEWEST,
		selected: false,
		type: SortType.NEWEST,
		order: OrderType.DESC
	},
	{
		label: 'Most Relevant',
		key: SortOptionKey.MOST_RELEVANT,
		selected: false,
		type: SortType.MOST_RELEVANT,
		order: OrderType.A1
	},
	{
		label: 'Most Helpful',
		key: SortOptionKey.MOST_HELPFUL,
		selected: false,
		type: SortType.MOST_HELPFUL,
		order: OrderType.DESC
	},
	{
		label: 'Highest Rated',
		key: SortOptionKey.HIGHEST_RATED,
		selected: false,
		type: SortType.HIGHEST_RATED,
		order: OrderType.DESC
	},
	{
		label: 'Lowest Rated',
		key: SortOptionKey.LOWEST_RATED,
		selected: false,
		type: SortType.LOWEST_RATED,
		order: OrderType.ASC
	},
	{
		label: 'Oldest',
		key: SortOptionKey.OLDEST,
		selected: false,
		type: SortType.OLDEST,
		order: OrderType.ASC
	}
];

export const RATING_DROPDOWN_OPTIONS: DropdownSelect[] = [
	{ label: '5 Star', key: '5', selected: false },
	{ label: '4 Star', key: '4', selected: false },
	{ label: '3 Star', key: '3', selected: false },
	{ label: '2 Star', key: '2', selected: false },
	{ label: '1 Star', key: '1', selected: false }
];
